import {ViewBase} from "@/rawdogjs/src/core/viewBase";
import {IView} from "@/rawdogjs/src/interfaces/IView";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";
import {CleaningCalculatorPresenter} from "./cleaningCalculatorPresenter";
import {CleaningQuoteResult} from "./cleaningCalculator";

export class CleaningCalculatorView extends ViewBase implements IView {

    public _presenter: CleaningCalculatorPresenter;

    constructor(viewName: string, router: Router, dependencyContainer: ParcelDependencyContainer, presenter: CleaningCalculatorPresenter) {
        super(viewName, router, dependencyContainer);
        this._presenter = presenter;
    }

    public setPresenter(presenter: CleaningCalculatorPresenter) {
        this._presenter = presenter;
    }

    public render(): void {
    }

    public setBedrooms(value: number): void {
        const el = this.$element.querySelector<HTMLSelectElement>('#bedrooms-input');
        if (el) el.value = String(value);
    }

    public setBathrooms(value: number): void {
        const el = this.$element.querySelector<HTMLSelectElement>('#bathrooms-input');
        if (el) el.value = String(value);
    }

    public setResult(result: CleaningQuoteResult): void {
        const price = this.$element.querySelector('#estimated-price');
        if (price) price.textContent = result.priceLabel;

        const disclaimer = this.$element.querySelector('#disclaimer');
        if (disclaimer) disclaimer.textContent = result.disclaimer;
    }

    public onBedroomsChange(callback: (value: number) => void): void {
        const el = this.$element.querySelector<HTMLSelectElement>('#bedrooms-input');
        if (el) {
            el.addEventListener('change', () => {
                callback(parseFloat(el.value));
            });
        }
    }

    public onBathroomsChange(callback: (value: number) => void): void {
        const el = this.$element.querySelector<HTMLSelectElement>('#bathrooms-input');
        if (el) {
            el.addEventListener('change', () => {
                callback(parseFloat(el.value));
            });
        }
    }

    public onContinue(callback: () => void): void {
        this.addOnClickHandler('#btn-continue', () => {
            callback();
        });
    }

}
